module.exports = __webpack_public_path__ + "../resources/img/storebadge_it.0a6a96b9.svg";